import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/src/app/learn/case-studies/[slug]/case-studies.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/BlogPageContent.jsx");
